import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableHead, FormControlLabel, Switch } from '@mui/material';
import { currencyFormat, formatNumber } from '../../../utils/number';
import { dateFormat } from '../../../utils/date';
import GenericTablePaginationActions from '../../../component/generic/GenericTablePaginationActions';

const columns = [
    { id: 'idUnidade', label: 'ID Unidade', minWidth: 80 },
    { id: 'descricao', label: 'Nome', minWidth: 200 },
    { id: 'grupoProdutoDescricao', label: 'Grupo', minWidth: 100 },
    { id: 'dataVendaItem', label: 'Data', minWidth: 50, align: 'right'  },
    { id: 'quantidade', label: 'Quantidade', minWidth: 100, align: 'right' },
    { id: 'valorTotal', label: 'Valor total', minWidth: 100, align: 'right' },
    { id: 'somaNoTotal', label: 'No total', minWidth: 80, align: 'center' },
]

export default function ListProduct({ data }) {

    // console.log('KpiTable', data)

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [includeOutOfTotal, setIncludeOutOfTotal] = React.useState(false);
    const filteredData = includeOutOfTotal ? data : data.filter(row => row.somaNoTotal);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData?.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div>
            <FormControlLabel
                control={
                    <Switch
                        checked={includeOutOfTotal}
                        onChange={(e) => { setIncludeOutOfTotal(e.target.checked); setPage(0); }}
                        size="small"
                    />
                }
                label="Incluir itens fora do total"
                sx={{ mb: 1 }}
            />
            {/* <Card> */}
            <TableContainer elevation={0} component={Paper}>
                <Table stickyHeader >
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {(rowsPerPage > 0
                            ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : filteredData
                        ).map((row,index) => (
                            <TableRow key={index}>
                                <TableCell  >
                                    {row.idUnidade}
                                </TableCell>
                                <TableCell align="left" component="th">
                                    {row.descricao}
                                </TableCell>
                                <TableCell align="left">
                                    {row.grupoProdutoDescricao}
                                </TableCell>
                                <TableCell align="right">
                                    {dateFormat(row.dataVendaItem,{pattern: 'dd/MM/yyyy'})}
                                </TableCell>
                                <TableCell align="right">
                                    {formatNumber(row.quantidade, {style: 'decimal', minimumFractionDigits: '3'})}
                                </TableCell>
                                <TableCell align="right">
                                    {currencyFormat(row.valorTotal, { simbol: '' })}
                                </TableCell>
                                <TableCell align="center">
                                    {row.somaNoTotal ? '✓' : '✗'}
                                </TableCell>
                            </TableRow>
                        ))}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={8} />
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, { label: 'Todos', value: -1 }]}
                                colSpan={8}
                                count={filteredData?.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                labelRowsPerPage='linhas por página'
                                SelectProps={{
                                    inputProps: {
                                        'aria-label': 'linhas por página',
                                    },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={GenericTablePaginationActions}
                            />
                        </TableRow>

                    </TableFooter>

                </Table>
            </TableContainer>
            {/* </Card> */}
        </div>
    )
}